import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useSplitQuotesByStatus } from '../hooks/useSplitQuotesByStatus';
import { useContainerWidth } from '../hooks/useContainerWidth';
import { dataModel } from '../dataModels/dataModel';

export const QuotesContext = createContext();

const QuotesContextProvider = ({ children }) => {
  const { userID, svocID, role } = useThdCustomer();
  const { data, loading, error, refetch } = useDataModel('quoteList', {
    variables: {
      userId: role !== 'ADMIN' ? userID : null,
      svocId: svocID,
      pageNumber: '1',
      pageSize: '20',
      sortBy: 'createdDt',
      sortOrder: 'desc',
      quoteStatus: 'all',
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });
  const quoteList = data?.quoteList || [];
  const quotes = quoteList?.quotes || [];

  const [selectedTab, setSelectedTab] = useState('active');
  const [containerRef, containerWidth] = useContainerWidth();
  const { activeQuotes, expiredQuotes } = useSplitQuotesByStatus(quotes);
  const hasQuotes = quotes && quotes.length > 0;
  const showTabs = activeQuotes.length > 0 && expiredQuotes.length > 0;
  const refreshQuotes = async () => {
    try {
      // Force a network request by passing fetchPolicy
      const result = await refetch({
        fetchPolicy: 'network-only'
      });

      return result;
    } catch (refetchError) {
      // eslint-disable-next-line no-console
      console.error('RefreshQuotes: Refetch failed', refetchError);
      return refetchError;
    }
  };
  return (
    <QuotesContext.Provider value={{
      quotes,
      loading,
      error,
      refreshQuotes,
      containerWidth,
      containerRef,
      activeQuotes,
      expiredQuotes,
      hasQuotes,
      showTabs,
      selectedTab,
      setSelectedTab
    }}
    >
      {children}
    </QuotesContext.Provider>
  );
};

QuotesContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const QuotesProvider = ({ children }) => {
  return (
    <QuotesContextProvider>
      {children}
    </QuotesContextProvider>
  );
};

QuotesProvider.propTypes = {
  children: PropTypes.node.isRequired
};

QuotesProvider.dataModel = dataModel;
